class UspBar extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Accessibility verbeteringen
		this.initAccessibility();
	}

	handleResize() {
		// Responsive gedrag wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const items = this.querySelectorAll('.usp-bar__item');
		items.forEach((item, index) => {
			item.setAttribute('aria-label', `USP item ${index + 1}`);
		});
	}
}

// Registreer de custom element
customElements.define('usp-bar', UspBar);
